import { apiUTCToLocalDateTime } from "@jugl-web/utils";
import format from "date-fns/format";
import isThisYear from "date-fns/isThisYear";
import { useMemo } from "react";

export const CRMInfoMessage: React.FC<{
  message: string;
  timestamp: string;
  isBlocked?: boolean;
}> = ({ message, timestamp, isBlocked }) => {
  const localDate = useMemo(
    () => apiUTCToLocalDateTime(timestamp),
    [timestamp]
  );

  return (
    <div className="mx-auto flex max-w-[400px] flex-col items-center justify-center py-4 text-center">
      <span className="font-secondary text-[13px] leading-[150%] font-medium text-[#828282]">
        {isBlocked ? `${message} 🚫` : message}
      </span>
      <span className="font-secondary text-xs leading-[140%] text-dark-700">
        {format(
          localDate,
          isThisYear(localDate) ? "d MMM, h:mm a" : "d MMM yyyy, h:mm a"
        )}
      </span>
    </div>
  );
};
